export const CLASS_NAMES = {
  title: 'text-20-24-em mb-4',
  titleHighlight: 'text-gradient-b',
  buttonWrapper: 'flex flex-row items-stretch justify-stretch',
  button: 'w-full mt-4',
  notice: 'text-neutral-700 block mt-4',
};
